import i18n from 'utils/i18n';
// 个人中心-资产管理
import capi from '../capi/instance';
import { CommonRes, virtualmanType } from 'types/index';
import { create } from 'lodash';
const { t } = i18n;
export enum SortOrder {
  ASC = 0,
  DES = 1,
}
export interface CommonListRes {
  offset: number;
  limit: number;
  totalCount: number;
}
export interface GetServiceQuotaListReq {
  serviceTypeList: string[];
  sortRuleList: {
    sortName: string;
    sortOrder: SortOrder;
  }[];
  limit: number;
  offset: number;
}

export enum QuotaTypeEnum {
  sample = 'ImageAsset',
  sampleTimbre = 'TimbreAsset',
  smallSampleGeneral2DImageAsset = 'SmallSampleGeneral2DImageAsset',
  smallSample4K2DImageAsset = 'SmallSample4K2DImageAsset',
  smallSamplePhoto2DImageAsset = 'SmallSamplePhoto2DImageAsset',
  zeroShotTimbreAsset = 'ZeroShotTimbreAsset',
  // realMan3DImageInternalAsset = 'RealMan3DImageInternalAsset',
  // cartoon3DImageInternalAsset = 'Cartoon3DImageInternalAsset',
  // halfRealistic3DImageInternalAsset = 'HalfRealistic3DImageInternalAsset',
  // 国际站只有这一个3D类目
  realMan3DImageAsset = 'RealMan3DImageAsset',
  zeroShotMultiTimbreAsset = 'ZeroShotMultiTimbreAsset',
}

// 在架服务类型
export enum OnlineTypeEnum {
  SmallSampleImageRenewalAsset = 'SmallSampleImageRenewalAsset',
  SmallSampleGeneralImageRenewalAsset = 'SmallSampleGeneralImageRenewalAsset',
  RealMan3DImageRenewalAsset = 'RealMan3DImageRenewalAsset',
  TimbreRenewalAsset = 'TimbreRenewalAsset',
  ZeroShotMultiTimbreRenewalAsset = 'ZeroShotMultiTimbreRenewalAsset',
}

export const OnlineTypeMap = {
  [OnlineTypeEnum.SmallSampleImageRenewalAsset]: t('2D形象-专属口型'),
  [OnlineTypeEnum.SmallSampleGeneralImageRenewalAsset]: t('2D形象-通用口型'),
  [OnlineTypeEnum.RealMan3DImageRenewalAsset]: t('3D形象'),
  [OnlineTypeEnum.TimbreRenewalAsset]: t('音色定制'),
  [OnlineTypeEnum.ZeroShotMultiTimbreRenewalAsset]: t('声音复刻（极速版-小语种）'),
};

export const QuotaTypeMap = {
  [QuotaTypeEnum.sample]: t('2D小样本（专属口型）'),
  [QuotaTypeEnum.sampleTimbre]: t('声音复刻（基础版）'),
  [QuotaTypeEnum.smallSampleGeneral2DImageAsset]: t('2D小样本（通用口型）'),
  [QuotaTypeEnum.smallSample4K2DImageAsset]: t('2D小样本（高精版本）'),
  [QuotaTypeEnum.smallSamplePhoto2DImageAsset]: t('2D小样本（照片数字人）'),
  [QuotaTypeEnum.zeroShotTimbreAsset]: t('声音复刻（极速版）'),
  // [QuotaTypeEnum.realMan3DImageInternalAsset]: t('3D写实'),
  // [QuotaTypeEnum.cartoon3DImageInternalAsset]: t('3D卡通'),
  // [QuotaTypeEnum.halfRealistic3DImageInternalAsset]: t('3D半写实'),
  [QuotaTypeEnum.realMan3DImageAsset]: t('3D写实'),
  [QuotaTypeEnum.zeroShotMultiTimbreAsset]: t('声音复刻（极速版-小语种）'),
};

export enum OrderSourceType {
  offline = 0,
  offcial = 1,
  trial = 2,
  giving = 4,
}
export enum ValidType {
  valid = 0,
  invalid,
}
export interface ServiceQuotaItem {
  /**
   * 2d小样本 | 小样本音色
   */
  serviceType: QuotaTypeEnum;
  effectiveTime: string;
  expireTime: string;
  quotaNum: number;
  remainQuotaNum: number;
  /**
   * 0线下开通，1官网下单
   */
  orderSource: OrderSourceType;
  orderId: string;
  quotaId: number;
  /**
   * 是否有效:0有效,1无效
   */
  isValid: ValidType;
  availableRemainDays: number;
  /**
   * 可分配量
   */
  allocateNum: number;
}

export interface OnlineTypeItem extends Omit<ServiceAssetItem, 'serviceType'> {
  serviceType: OnlineTypeEnum;
}

interface GetServiceQuotaListRes extends CommonListRes {
  serviceQuotaList: ServiceQuotaItem[];
}

// 获取配额服务资产列表
export const getServiceQuotaList = async (data: GetServiceQuotaListReq) => {
  const res = await capi<GetServiceQuotaListReq, GetServiceQuotaListRes>('DescribeServiceQuotaList', data);
  return res;
};

export enum VirtualmanType {
  real_man_2d = 'real_man_2d',
  small_sample_2d = 'small_sample_2d',
  real_man_3d = 'real_man_3d',
  cartoon_3d = 'cartoon_3d',
  half_realistic_3d = 'half_realistic_3d',
  small_sample_general_2d = 'small_sample_general_2d',
  small_sample_4k_2d = 'small_sample_4k_2d',
  small_sample_photo_2d = 'small_sample_photo_2d',
  no_train_video = 'no_train_video',
  no_train_photo = 'no_train_photo',
}
export enum ImageType {
  general = 'general',
  custom = 'custom',
}
export interface GetImageAssetListReq {
  imageTypeList?: ImageType[];
  virtualmanTypeList?: VirtualmanType[] | string[];
  name?: string;
  virtualmanKey?: string;
  sortRuleList: {
    sortName: string;
    sortOrder: SortOrder;
  }[];
  limit: number;
  offset: number;
}

export interface ImageResolution {
  resolution: string;
  virtualmanKey: string;
  resourceId: number;
  effectiveTime: string;
  expireTime: string;
  /**
   * 是否有效: 0有效,1无效
   */
  isValid: ValidType;
  subAccountList: {
    subUin: string;
    subUserName: string;
  }[];
  creatorUin: string;
  creator: string;
}
export interface ImageAssetItem {
  imageType: ImageType;
  /**
   * 2D精品-real_man_2d，2D小样本-small_sample_2d，3D写实-real_man_3d，3D卡通-cartoon_3d，3D半写实-half_realistic_3d
   */
  virtualmanType: VirtualmanType;
  /**
   * 头像code
   */
  virtualmanResourceCode: string;
  /**
   * 头像名称
   */
  virtualmanResourceName: string;
  defaultTimbreCode: string;
  defaultTimbreName: string;
  imageAssetResolutionList: ImageResolution[];
  previewUrl: string;
  availableRemainDays: number;
  clothesCode: string;
  clothesName: string;
  poseCode: string;
  poseName: string;
  anchorCode: string;
  vid: string; // 两个vkey 相加
  renewalDuration?: number; // 续期时长
}
interface GetImageAssetListRes extends CommonListRes {
  imageAssetConfigList: ImageAssetItem[];
}

// 获取形象资产列表
export const getImageAssetList = async (data: GetImageAssetListReq) => {
  const res = await capi<GetImageAssetListReq, GetImageAssetListRes>('DescribeImageAssetList', data);
  return res;
};

/**
 * 1-精品，2-定制
 */
export enum TimbreAssetsType {
  Premium = 1,
  Custom = 2,
}
/**
 * 音色子资产类型：1-小样本音色，2精品音色
 */
export enum TimbreSubAssetsType {
  Sample = 1,
  Premium = 2,
  Fast = 3,
  Multiple = 4,
}

export interface GetTimbreAssetListReq {
  sortRuleList: {
    sortName: string;
    sortOrder: SortOrder;
  }[];
  limit: number;
  offset: number;
  timbreAssetsTypeList: TimbreAssetsType[];
  timbreSubAssetsTypeList: TimbreSubAssetsType[];
  name: string;
}

export interface TimbreAssetItem {
  timbreAssetsType: TimbreAssetsType;
  timbreSubAssetsType: TimbreSubAssetsType;
  name: string;
  expireTime: string;
  effectiveTime: string;
  timbreDemo: string;
  timbreCode: string;
  timbreCodeName: number;
  /**
   * 是否有效:0有效,1无效
   */
  isValid: ValidType;
  availableRemainDays: number;
  defaultSpeed: string;
  subAccountList: {
    subUin: string;
    subUserName: string;
  }[];
  creatorUin: string;
  creator: string;
  renewalDuration?: number; // 续期时长
  vid: string;
}
interface GetTimbreAssetListRes extends CommonListRes {
  timbreAssetConfigList: TimbreAssetItem[];
}

// 获取音色资产列表
export const getTimbreAssetList = async (data: GetTimbreAssetListReq) => {
  const res = await capi<GetTimbreAssetListReq, GetTimbreAssetListRes>('DescribeTimbreAssetList', data);
  return res;
};

/**
 * InteractConcurrencyType             ServiceType = 1  //2D小样本交互
  BroadcastHourType                   ServiceType = 2  //2D小样本播报小时包
  BroadcastConcurrencyType            ServiceType = 3  //2D小样本播报并发
  ImageAssetType                      ServiceType = 4  //形象定制
  TimbreAssetType                     ServiceType = 5  //音色定制
  RealMan2DInteractConcurrency        ServiceType = 6  //2D精品交互并发
  RealMan3DInteractConcurrency        ServiceType = 7  //3D写实交互并发
  HalfRealistic3DInteractConcurrency  ServiceType = 8  //3D半写实交互并发
  Cartoon3DInteractConcurrency        ServiceType = 9  //3D卡通交互并发
  RealMan2DBroadcastHour              ServiceType = 10 //2D精品播报小时包
  RealMan3DBroadcastHour              ServiceType = 11 //3D写实播报小时包
  HalfRealistic3DBroadcastHour        ServiceType = 12 //3D半写实播报小时包
  Cartoon3DBroadcastHour              ServiceType = 13 //3D卡通播报小时包
  RealMan2DBroadcastConcurrency       ServiceType = 14 //2D精品播报并发
  RealMan3DBroadcastConcurrency       ServiceType = 15 //3D写实播报并发
  HalfRealistic3DBroadcastConcurrency ServiceType = 16 //3D半写实播报并发
  Cartoon3DBroadcastConcurrency       ServiceType = 17 //3D卡通播报并发
  TimbreHourType                      ServiceType = 18
  TimbreConcurrencyType               ServiceType = 19
 */
export interface GetPersonalAssetTypeRes {
  assetTypeList: Array<
  {
    typeName: string;
    assetList: Array<{
      code: string;
      name: string;
    }>
  }>
}

// 获取购买类型菜单
export const getPersonalAssetType = async () => {
  const res = await capi<{}, GetPersonalAssetTypeRes>('DescribePersonalAssetType', {});
  return res;
};

export const ServiceAssetsType = {
  InteractiveConcurrency: t('交互并发'),
  BroadcastConcurrency: t('播报并发'),
  BroadcastHour: t('播报小时包'),
  TimbreHour: t('声音合成小时包'),
  // HighPrecisionInteract: t('准高清交互并发'),
  WebGLBillingPackage: t('云端驱动计费次数包'),
  // UnityBillingPackage: t('Unity端渲染次数包'),
  // UEBillingPackage: t('UE端渲染次数包'),
  RealMan3DDriver: t('3D写实云端驱动'),
  HalfRealistic3DDriver: t('3D半写实云端驱动'),
  Cartoon3DDriver: t('3D卡通云端驱动'),
  NoTrainVideoBroadcastHour:t('2D免训练播报小时包（视频素材）'),
  NoTrainVideoBroadcastConcurrency:t('2D免训练播报并发（视频素材）'),
  NoTrainPhotoBroadcastHour:t('2D免训练播报小时包（照片素材）'),
  NoTrainPhotoBroadcastConcurrency:t('2D免训练播报并发（照片素材）'),
  TerminalRendering2DSDKAuthorization:t('2D小样本端渲染SDK授权年包-按应用'),
  TerminalRendering2DSDKAuthorizationDevice:t('2D小样本端渲染SDK授权年包-按设备'),
  // TerminalRendering3DSDKAuthorizationH5:t('3D端渲染SDK授权-H5'),
  // TerminalRendering3DSDKAuthorizationUE:t('3D端渲染SDK授权-UE高精度'),
  // Image3DDesignAsset:t('虚拟形象资产设计服务')
};
export const InactiveServiceAssetsType = [
  ServiceAssetsType.InteractiveConcurrency,
  ServiceAssetsType.BroadcastConcurrency,
  ServiceAssetsType.TerminalRendering2DSDKAuthorization,
  ServiceAssetsType.TerminalRendering2DSDKAuthorizationDevice,
  // ServiceAssetsType.TerminalRendering3DSDKAuthorizationH5,
  // ServiceAssetsType.TerminalRendering3DSDKAuthorizationUE,
  // ServiceAssetsType.Image3DDesignAsset
];
export type ServiceAssetsTypeKeys = keyof typeof ServiceAssetsType;

export enum ServiceAssetsSubEnum {
  Timbre = 'timbre',
}

export type ServiceAssetsSubType = ServiceAssetsSubEnum | VirtualmanType;

export const ServiceAssetsMapData = {
  InteractConcurrency: { prefix: ServiceAssetsType.InteractiveConcurrency, suffix: VirtualmanType.small_sample_2d },
  BroadcastHour: { prefix: ServiceAssetsType.BroadcastHour, suffix: VirtualmanType.small_sample_2d },
  BroadcastConcurrency: { prefix: ServiceAssetsType.BroadcastConcurrency, suffix: VirtualmanType.small_sample_2d },
  RealMan2DInteractConcurrency: {
    prefix: ServiceAssetsType.InteractiveConcurrency,
    suffix: VirtualmanType.real_man_2d,
  },
  RealMan3DInteractConcurrency: {
    prefix: ServiceAssetsType.InteractiveConcurrency,
    suffix: VirtualmanType.real_man_3d,
  },
  HalfRealistic3DInteractConcurrency: {
    prefix: ServiceAssetsType.InteractiveConcurrency,
    suffix: VirtualmanType.half_realistic_3d,
  },
  Cartoon3DInteractConcurrency: { prefix: ServiceAssetsType.InteractiveConcurrency, suffix: VirtualmanType.cartoon_3d },
  RealMan2DBroadcastHour: { prefix: ServiceAssetsType.BroadcastHour, suffix: VirtualmanType.real_man_2d },
  RealMan3DBroadcastHour: { prefix: ServiceAssetsType.BroadcastHour, suffix: VirtualmanType.real_man_3d },
  HalfRealistic3DBroadcastHour: { prefix: ServiceAssetsType.BroadcastHour, suffix: VirtualmanType.half_realistic_3d },
  Cartoon3DBroadcastHour: { prefix: ServiceAssetsType.BroadcastHour, suffix: VirtualmanType.cartoon_3d },
  RealMan2DBroadcastConcurrency: { prefix: ServiceAssetsType.BroadcastConcurrency, suffix: VirtualmanType.real_man_2d },
  RealMan3DBroadcastConcurrency: { prefix: ServiceAssetsType.BroadcastConcurrency, suffix: VirtualmanType.real_man_3d },
  HalfRealistic3DBroadcastConcurrency: {
    prefix: ServiceAssetsType.BroadcastConcurrency,
    suffix: VirtualmanType.half_realistic_3d,
  },
  Cartoon3DBroadcastConcurrency: { prefix: ServiceAssetsType.BroadcastConcurrency, suffix: VirtualmanType.cartoon_3d },
  SmallSampleGeneral2DInteractConcurrency: {
    prefix: ServiceAssetsType.InteractiveConcurrency,
    suffix: VirtualmanType.small_sample_general_2d,
  },
  SmallSampleGeneral2DBroadcastHour: {
    prefix: ServiceAssetsType.BroadcastHour,
    suffix: VirtualmanType.small_sample_general_2d,
  },
  SmallSampleGeneral2DBroadcastConcurrency: {
    prefix: ServiceAssetsType.BroadcastConcurrency,
    suffix: VirtualmanType.small_sample_general_2d,
  },
  SmallSample4K2DInteractConcurrency: {
    prefix: ServiceAssetsType.InteractiveConcurrency,
    suffix: VirtualmanType.small_sample_4k_2d,
  },
  SmallSample4K2DBroadcastHour: {
    prefix: ServiceAssetsType.BroadcastHour,
    suffix: VirtualmanType.small_sample_4k_2d,
  },
  SmallSample4K2DBroadcastConcurrency: {
    prefix: ServiceAssetsType.BroadcastConcurrency,
    suffix: VirtualmanType.small_sample_4k_2d,
  },
  SmallSamplePhoto2DInteractConcurrency: {
    prefix: ServiceAssetsType.InteractiveConcurrency,
    suffix: VirtualmanType.small_sample_photo_2d,
  },
  SmallSamplePhoto2DBroadcastHour: {
    prefix: ServiceAssetsType.BroadcastHour,
    suffix: VirtualmanType.small_sample_photo_2d,
  },
  SmallSamplePhoto2DBroadcastConcurrency: {
    prefix: ServiceAssetsType.BroadcastConcurrency,
    suffix: VirtualmanType.small_sample_photo_2d,
  },
  TimbreHour: { prefix: ServiceAssetsType.TimbreHour, suffix: 'general' },
  // SmallSampleHighPrecisionInteractConcurrency: {
  //   prefix: ServiceAssetsType.HighPrecisionInteract,
  //   suffix: VirtualmanType.small_sample_2d,
  // },
  WebGLBillingPackageAsset: {
    prefix: ServiceAssetsType.WebGLBillingPackage,
    suffix: 'general',
  },
  // UnityBillingPackageAsset: {
  //   prefix: ServiceAssetsType.UnityBillingPackage,
  //   suffix: 'all',
  // },
  // UEBillingPackageAsset: {
  //   prefix: ServiceAssetsType.UEBillingPackage,
  //   suffix: 'all',
  // },
  RealMan3DDriverAsset: {
    prefix: ServiceAssetsType.RealMan3DDriver,
    suffix: VirtualmanType.real_man_3d,
  },
  HalfRealistic3DDriverAsset: {
    prefix: ServiceAssetsType.HalfRealistic3DDriver,
    suffix: VirtualmanType.half_realistic_3d,
  },
  Cartoon3DDriverAsset: {
    prefix: ServiceAssetsType.Cartoon3DDriver,
    suffix: VirtualmanType.cartoon_3d,
  },
  NoTrainVideoBroadcastConcurrency: {
    prefix: ServiceAssetsType.NoTrainVideoBroadcastConcurrency,
    suffix: VirtualmanType.no_train_video,
  },
  NoTrainVideoBroadcastHour: {
    prefix: ServiceAssetsType.NoTrainVideoBroadcastHour,
    suffix: VirtualmanType.no_train_video,
  },
  NoTrainPhotoBroadcastHour: {
    prefix: ServiceAssetsType.NoTrainPhotoBroadcastHour,
    suffix: VirtualmanType.no_train_photo,
  },
  NoTrainPhotoBroadcastConcurrency: {
    prefix: ServiceAssetsType.NoTrainPhotoBroadcastConcurrency,
    suffix: VirtualmanType.no_train_photo,
  },
  TerminalRendering2DSDKAuthorization: {
    prefix: ServiceAssetsType.TerminalRendering2DSDKAuthorization,
    suffix: 'general',
  },
  TerminalRendering2DSDKAuthorizationDevice: {
    prefix: ServiceAssetsType.TerminalRendering2DSDKAuthorizationDevice,
    suffix: 'general',
  },
  // TerminalRendering3DSDKAuthorizationH5: {
  //   prefix: ServiceAssetsType.TerminalRendering3DSDKAuthorizationH5,
  //   suffix: 'general',
  // },
  // TerminalRendering3DSDKAuthorizationUE: {
  //   prefix: ServiceAssetsType.TerminalRendering3DSDKAuthorizationUE,
  //   suffix: 'general',
  // },
  // Image3DDesignAsset: {
  //   prefix: ServiceAssetsType.Image3DDesignAsset,
  //   suffix: 'general',
  // }
};
// 不区分形象类型的资产
export const serviceTypeOfIgnoreVirtualmanType = [
  ServiceAssetsType.WebGLBillingPackage,
  // ServiceAssetsType.UnityBillingPackage,
  // ServiceAssetsType.UEBillingPackage,
  ServiceAssetsType.NoTrainVideoBroadcastConcurrency,
  ServiceAssetsType.NoTrainVideoBroadcastHour,
  ServiceAssetsType.NoTrainPhotoBroadcastHour,
  ServiceAssetsType.NoTrainPhotoBroadcastConcurrency,
  ServiceAssetsType.TerminalRendering2DSDKAuthorization,
  ServiceAssetsType.TerminalRendering2DSDKAuthorizationDevice,
];

// 不支持分配的服务资产
export const serviceTypeOfIgnoreAssign = [
  'WebGLBillingPackageAsset',
  // 'UnityBillingPackageAsset',
  // 'UEBillingPackageAsset',
  'RealMan3DDriverAsset',
  'HalfRealistic3DDriverAsset',
  'Cartoon3DDriverAsset',
];

export type ServiceAssetsMapDataKeys = keyof typeof ServiceAssetsMapData;

export interface GetServiceAssetListReq {
  sortRuleList: {
    sortName: string;
    sortOrder: number;
  }[];
  limit: number;
  offset: number;
  serviceTypList: ServiceAssetsMapDataKeys[];
}

export interface LicenseInfo {
  licenseID: string; // 2D端渲染授权时LicenseID
  secretKey: string; // 2D端渲染授权时的密钥
  appID: string; // 应用标识
  appName: string;
  packageName: string;
  bundleID: string;
}

export interface ServiceAssetItem {
  serviceType: ServiceAssetsMapDataKeys;
  effectiveTime: string;
  expireTime: string;
  orderSource: OrderSourceType;
  orderId: number;
  quotaId: number;
  orderMilliseconds: number;
  remainMilliseconds: number;
  isValid: ValidType;
  availableRemainDays: number;
  concurrentUsedDays: number;
  concurrentRemainDays: number;
  allocateNum: number;
  ownerConsumeNum: number;
  concurrencyNum: number;
  quotaNum: number;
  remainQuotaNum: number;
  licenseInfo: LicenseInfo;
  billingResourceID: string;
}
interface GetServiceAssetListRes {
  serviceAssetList: ServiceAssetItem[];
  offset: number;
  limit: number;
  totalCount: number;
}

// 获取服务资产列表
export const getServiceAssetList = async (data: GetServiceAssetListReq) => {
  const res = await capi<GetServiceAssetListReq, GetServiceAssetListRes>('DescribeServiceAssetList', data);
  return res;
};

export interface GetInactiveServiceAssetListReq {
  sortRuleList: {
    sortName: string;
    sortOrder: number;
  }[];
  limit: number;
  offset: number;
  serviceTypList: ServiceAssetsMapDataKeys[];
  sourceStatus: string;
}
export interface InactiveServiceAssetItem {
  serviceType: ServiceAssetsMapDataKeys;
  effectiveTime: string;
  expireTime: string;
  orderSource: OrderSourceType;
  orderId: string;
  availableRemainDays: number;
  sourceStatus: number;
  activeTime: number;
  duration: number;
  concurrency: string;
  unit: number;
  subOrderId: string;
  orderState: number;
  licenseInfo: LicenseInfo;
  rejectReason: string;
}
interface GetInactiveServiceAssetListRes {
  billingFlowList: InactiveServiceAssetItem[];
  offset: number;
  limit: number;
  totalCount: number;
}
// 获取未激活服务资产列表
export const getInactiveServiceAssetList = async (data: GetInactiveServiceAssetListReq) => {
  const res = await capi<GetInactiveServiceAssetListReq, GetInactiveServiceAssetListRes>(
    'DescribeNotActiveServiceAssetList',
    data,
  );
  return res;
};

type PostActiveItemReq = {
  subOrderId: string;
};
// 激活未激活服务资产
export const postActiveItem = async (data: PostActiveItemReq) => {
  const res = await capi<PostActiveItemReq, {}>('ActivateServiceAsset', data);
  return res;
};

interface ActiveClientAppReq {
  orderID: string;
  subOrderID: string;
  appName: string;
  packageName?: string;
  bundleID?: string;
}

// 应用激活接口
export const requestActiveClientApp = async (data: ActiveClientAppReq) => {
  const res = await capi<ActiveClientAppReq, {}>('ActivateClientApp',data);
}

export interface GetConsumptionRecordListReq {
  quotaId: number;
  limit: number;
  offset: number;
}

export interface ConsumptionRecordItem {
  consumptionTime: string;
  workOrderId: string;
  operationType: number;
  /**
   * 消耗账户
   */
  consumeAccount: string;
  /**
   * 消耗账户uin
   */
  consumeAccountName: string;
  imageInfo: {
    previewUrl: string;
    virtualmanResourceCode: string;
    virtualmanResourceName: string;
  };
  timbreInfo: {
    timbreName: string;
  };
}

interface GetConsumptionRecordListRes extends CommonListRes {
  consumptionRecordList: ConsumptionRecordItem[];
}

// 获取消费记录
export const getConsumptionRecordList = async (data: GetConsumptionRecordListReq) => {
  const res = await capi<GetConsumptionRecordListReq, GetConsumptionRecordListRes>(
    'DescribeConsumptionRecordList',
    data,
  );
  return res;
};

export interface GetAllocateRecordsReq {
  assetId: number;
}

export interface AllocateRecord {
  allocateTime: string;
  num: number;
  uin: string;
  name: string;
  allocateId: number;
  expireTime: string;
}

interface GetAllocateRecordsRes extends CommonListRes {
  recordList: AllocateRecord[];
  totalNum: number;
  /**
   * 主账号消耗额度
   */
  consumeNum: number;
  /**
   * 已分配额度
   */
  allocatedNum: number;
  /**
   * 可分配额度
   */
  lastAllocateNum: number;
}

// 获取消费记录
export const getAllocateRecords = async (data: GetAllocateRecordsReq) => {
  const res = await capi<GetAllocateRecordsReq, GetAllocateRecordsRes>('DescribeAllocateRecord', data);
  return res;
};

type GetAssetSummaryReq = {};

export interface GetAssetSummaryRes {
  assetSummary: {
    /**
     * 可用2d小样本定额配置数量
     */
    availableSampleQuotaNum: number;
    /**
     * 可用2d小样本音色数量
     */
    availableSampleTimbreQuotaNum: number;
    /**
     * 在用形象定制形象资产数量
     */
    availableCustomImageAssetNum: number;
    /**
     * 在用形象租赁形象资产数量
     */
    availableGeneralImageAssetNum: number;
    /**
     * 在用即将失效形象资产数量
     */
    availableImpendingExpireImageAssetNum: number;
    /**
     * 在用声音资产数量
     */
    availableTimbreAssetNum: number;
    /**
     * 在用即将失效声音资产数量
     */
    availableImpendingExpireTimbreAssetNum: number;
    /**
     * 在用并发服务资产数量
     */
    availableConcurrencyServiceAssetNum: number;
    /**
     * 在用播报小时服务资产数量
     */
    availableBroadcastDurationServiceAssetNum: number;
    /**
     * 在用最近即将失效的时间
     */
    availableImpendingExpireTime: string;
    /**
     * 主账号时可分配的小样本配额数量
     */
    allocateSampleQuotaNum: number;
    /**
     * 主账号时可分配的小样本音色配额数量
     */
    allocateSampleTimbreQuotaNum: number;
    /**
     * 主账号时可分配的在用并发服务资产数量
     */
    allocateConcurrencyAssetNum: number;
    /**
     * 主账号时可分配的播报小时服务资产数量
     */
    allocateBroadcastDurationAssetNum: number;
  };
}

// 获取资产概况
export const getAssetSummary = async () => {
  const res = await capi<GetAssetSummaryReq, GetAssetSummaryRes>('DescribeAssetSummary', {});
  return res;
};

type SaveImageAssetReq = {
  virtualmanKeys: string[];
  defaultTimbreCode: string;
};

type SaveImageAssetRes = {} & CommonRes;

// 保存形象资产
export const saveImageAsset = async (data: SaveImageAssetReq) => {
  const res = await capi<SaveImageAssetReq, SaveImageAssetRes>('SaveImageAsset', data);
  return res;
};

type SaveTimbreReq = {
  timbreCode: string;
  defaultSpeed: string;
};

type SaveTimbreRes = {} & CommonRes;
// 保存音色资产
export const saveTimbreAsset = async (data: SaveTimbreReq) => {
  const res = await capi<SaveTimbreReq, SaveTimbreRes>('SaveTimbreAsset', data);
  return res;
};

type GetSecretReq = { hide?: number };

export interface GetSecretRes {
  inGray: boolean;
  customerSecrets: {
    accessKey: string;
    secretKey: string;
  }[];
  inSession?: boolean;
}

// 获取资产概况
export const getSecret = async (data: GetSecretReq = {}) => {
  const res = await capi<GetSecretReq, GetSecretRes>('DescribeSecret', data);
  return res;
};

// 新客领用试用资产
type GetTrialAssetsReq = null;
type TrialType = 0 | 1;

export interface TrailInfo {
  /**
   * 0:音视频播报，1:会话互动
   */
  trialType: TrialType;
  effectTime: string;
  efficacyTime: string;
  /**
   * 领用状态 0：未领用，1：已领用，2：存在正式购买（置灰）
   */
  status: 0 | 1 | 2;
  /**
   * 剩余续期(领用)次数
   */
  lastCount: number;
}

export interface GetTrialAssetsRes {
  trialList: TrailInfo[];
}

// 获取资产概况
export const getTrialAssets = async () => {
  const res = await capi<GetTrialAssetsReq, GetTrialAssetsRes>('DescribeCustomNewTrial', null);
  return res;
};

type setTrialReq = {
  trialType: TrialType;
};
type setTrialRes = {} & CommonRes;

// 领用
export const setTrial = async (data: setTrialReq) => {
  const res = await capi<setTrialReq, setTrialRes>('RenewTrial', data, true);
  return res;
};

type ModifySubExpireTimeReq = {
  allocateId: number;
  expireTime: string;
  operationMsg: string;
};
type ModifySubExpireTimeRes = {} & CommonRes;
export const modifySubExpireTime = async (data: ModifySubExpireTimeReq) => {
  const res = await capi<ModifySubExpireTimeReq, ModifySubExpireTimeRes>('ModifySubExpireTime', data);
  return res;
};

type AllocateImageReq = {
  resourceId: number;
  subUin: string[];
};
type AllocateImageRes = {} & CommonRes;
// 形象增加子用户
export const assignImageToSub = async (data: AllocateImageReq) => {
  const res = await capi<AllocateImageReq, AllocateImageRes>('AllocateImage', data);
  return res;
};
// 修改分配给子用户的形象的过期时间
type ModifySubImageExpireTimeReq = {
  resourceId: number;
  subUin: string[];
  expireTime: string;
};
type ModifySubImageExpireTimeRes = {} & CommonRes;
export const modifySubImageExpire = async (data: ModifySubImageExpireTimeReq) => {
  const res = await capi<ModifySubImageExpireTimeReq, ModifySubImageExpireTimeRes>('ModifySubImageExpireTime', data);
  return res;
};

type AllocateTimbreReq = {
  timbreCode: string;
  subUin: string[];
};
type AllocateTimbreRes = {} & CommonRes;
// 音色增加子用户
export const assignTimbreToSub = async (data: AllocateTimbreReq) => {
  const res = await capi<AllocateTimbreReq, AllocateTimbreRes>('AllocateTimbre', data);
  return res;
};
// 修改分配给子用户的形象的过期时间
type ModifySubTimbreExpireTimeReq = {
  timbreCode: string;
  subUin: string[];
  expireTime: string;
};
type ModifySubTimbreExpireTimeRes = {} & CommonRes;
export const modifySubTimbreExpire = async (data: ModifySubTimbreExpireTimeReq) => {
  const res = await capi<ModifySubTimbreExpireTimeReq, ModifySubTimbreExpireTimeRes>('ModifySubTimbreExpireTime', data);
  return res;
};

// 分配给子用户配额或者服务资产
type AllocateQuotaServiceReq = {
  assetId: number;
  num: number;
  subUin: string;
};
type AllocateQuotaServiceRes = { operationQuotaId: string } & CommonRes;
export const allocateQuotaService = async (data: AllocateQuotaServiceReq) => {
  const res = await capi<AllocateQuotaServiceReq, AllocateQuotaServiceRes>('AllocateQuotaService', data);
  return res;
};
// 形象分配配额
type RenewImageAssetsReq = {
  renewItems: { virtualmanKeys: string[]; monthNum: number; originExpireTime: string }[];
};
type RenewImageAssetsRes = CommonRes;
export const renewImageAssets = async (data: RenewImageAssetsReq) => {
  const res = await capi<RenewImageAssetsReq, RenewImageAssetsRes>('RenewImageAssets', data);
  return res;
};
// 音色分配配额
type RenewTimbreAssetsReq = {
  renewItems: { timbreCode: string; monthNum: number; originExpireTime: string }[];
};
type RenewTimbreAssetsRes = CommonRes;
export const renewTimbreAssets = async (data: RenewTimbreAssetsReq) => {
  const res = await capi<RenewTimbreAssetsReq, RenewTimbreAssetsRes>('RenewTimbreAssets', data);
  return res;
};

export enum QuotaSummaryType {
  small_sample_2d = 'SmallSampleImageRenewalAsset',
  small_sample_general_2d = 'SmallSampleGeneralImageRenewalAsset',
  '3d' = 'RealMan3DImageRenewalAsset',
  timbre = 'TimbreRenewalAsset',
  timbre_multi = 'ZeroShotMultiTimbreRenewalAsset',
}
// 获取服务配额
type DescribeServiceQuotaSummaryReq = {
  serviceTypeList: QuotaSummaryType[];
};
type ServiceQuotaSummaryItem = {
  remainQuotaNum: number;
  serviceType: QuotaSummaryType;
  totalQuotaNum: number;
};
export type DescribeServiceQuotaSummaryResRes = {
  details: ServiceQuotaSummaryItem[];
  remainQuotaNum: number;
  totalQuotaNum: number;
};
export const getServiceQuotaSummary = async (data: DescribeServiceQuotaSummaryReq) => {
  const res = await capi<DescribeServiceQuotaSummaryReq, DescribeServiceQuotaSummaryResRes>(
    'DescribeServiceQuotaSummary',
    data,
  );
  return res;
};

type DescribeThirdPartySecretRes = {
  thirdPartySecretList: ThirdPartySecret[];
};

export interface ThirdPartySecret {
  source: string; // tencent/azure
  keyType: number; // 1-TTS
  secretInfo: string; // json格式：腾讯云（tencent）的包含app_id、secret_id、secret_key,微软（azure）的包含subscription_key、region
  createTime: number;
  updateTime: number;
}

interface describeThirdPartySecretReq {
  source?: string;
  keyType?: number;
}
// 获取三方音色密钥列表
export const getThirdPartyTimbreKeyList = async (data?: describeThirdPartySecretReq) => {
  const res = await capi<describeThirdPartySecretReq, DescribeThirdPartySecretRes>(
    'DescribeThirdPartySecret',
    data || {},
  );
  return res;
};

type CreateThirdPartySecretReq = {
  source: string;
  keyType: number;
  secretInfo: string;
};

// 创建三方音色密钥
export const upsertThirdPartyTimbreKey = async (data: CreateThirdPartySecretReq) => {
  const res = await capi<CreateThirdPartySecretReq, DescribeThirdPartySecretRes>('CreateThirdPartySecret', data);
  return res;
};

